import React from 'react';

export type ExerciseLayout = 'mobile' | 'desktop';

export const ExerciseLayoutContext = React.createContext<ExerciseLayout>('mobile');

export function useExerciseLayout(): ExerciseLayout {
    return React.useContext(ExerciseLayoutContext);
}
